













import { Component, Vue } from 'vue-property-decorator'

/**
 * @title  辅助标题
 * @desc 头部添加辅助标题。
 */
@Component
export default class SubtitleExample extends Vue {
}
